import { render, staticRenderFns } from "./plane-model.vue?vue&type=template&id=2754dbf6&scoped=true&"
import script from "./plane-model.vue?vue&type=script&lang=js&"
export * from "./plane-model.vue?vue&type=script&lang=js&"
import style0 from "./plane-model.vue?vue&type=style&index=0&id=2754dbf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2754dbf6",
  null
  
)

export default component.exports